import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { getEstate } from '@/features/estates-property/api/estate';
import { requireDocumentsRead } from '@/features/permissions/route-permissions';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/documents'
)({
  validateSearch: zodValidator(
    z.object({
      order: fallback(z.enum(['asc', 'desc']), 'asc'),
    })
  ),
  loader: async (props) => {
    const estate = await getEstate(props.params.estateId);

    requireDocumentsRead(estate.metadata?.permissions, {
      type: 'estate',
      estateId: props.params.estateId,
    });
  },
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="documents" /> },
});
